import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import _en from './translations/en.json.mjs';
import React from 'react';
import { Modal, TextField } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { autobind } from '../../packages/@web-utilities/decorators/index.mjs';
import compose from '@shopify/react-compose';

var _class;
let InsertVideoModal = (_class = class InsertVideoModal extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      videoCode: ''
    };
  }
  render() {
    const {
      i18n,
      open
    } = this.props;
    const {
      videoCode
    } = this.state;
    return /*#__PURE__*/React.createElement(Modal, {
      title: i18n.translate('RichTextEditor.insertVideo'),
      open: open,
      onClose: this.handleOnClose,
      primaryAction: {
        content: i18n.translate('RichTextEditor.insertVideo'),
        onAction: this.handleOnInsertVideo
      },
      secondaryActions: [{
        content: i18n.translate('RichTextEditor.cancel'),
        onAction: this.handleOnClose
      }],
      sectioned: true
    }, /*#__PURE__*/React.createElement(TextField, {
      label: i18n.translate('InsertVideoModal.label'),
      helpText: i18n.translate('InsertVideoModal.helpText'),
      value: videoCode,
      autoComplete: "off",
      onChange: this.handleVideoCodeChange,
      multiline: 5
    }));
  }
  handleVideoCodeChange(newVideoCode) {
    this.setState({
      videoCode: newVideoCode
    });
  }
  handleOnClose() {
    this.props.onClose();
    this.setState({
      videoCode: ''
    });
  }
  handleOnInsertVideo() {
    const {
      onInsertVideo
    } = this.props;
    const {
      videoCode
    } = this.state;
    onInsertVideo(videoCode);
    this.setState({
      videoCode: ''
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleVideoCodeChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleVideoCodeChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOnClose", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleOnClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOnInsertVideo", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleOnInsertVideo"), _class.prototype)), _class);
var InsertVideoModal$1 = compose(withI18n({
  id: 'InsertVideoModal_5tobus',
  fallback: _en,
  translations(locale) {
    if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
      return;
    }
    return import( /* webpackChunkName: "InsertVideoModal_5tobus-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
  }
}))(InsertVideoModal);

export { InsertVideoModal$1 as default };
